<template>
  <create-update-customer-info
    :is-grocery-registration="true"
    @valid="handleValidation"
  />
</template>

<script setup lang="ts">
import CreateUpdateCustomerInfo from '@/components/Main/Operator/Registration/CreateUpdateCustomer.vue';

const emit = defineEmits(['valid']);
const handleValidation = (isValid: boolean) => {
  emit('valid', isValid);
};
</script>

<style scoped lang="scss"></style>
